import { redirect } from 'react-router-dom'
import { tokenService } from '../lib/token.service'

export const authLoader = () => {
  const user = tokenService.getUser()

  if (user && user.id !== '') {
    return redirect('dashboard')
  }

  return null
}
